// extracted by mini-css-extract-plugin
export default {"container":"container___faSCB","content":"content___eVr2D","form-content":"form-content___CWrLy","input":"input___pVnSm","img":"img___k64rw","text":"text___I7yjL"};